import React from "react"
import {adWrapper} from './ad-slice.module.scss';

const AdSlice = () => (
    <section className={`${adWrapper}`}>
        <div className="ad ad-md">
        </div>
    </section>
)

export default AdSlice
